import React from "react";
import {WeeksList,MonthsList} from './defaultList';
import moment from "moment";
import {isSet} from '../../../../../../Utils/CommonFunctions';

export const RecursiveWeeks = (weeksInBytes,selectedWeeks,value)=>{
    let passingValue = value;
    if(weeksInBytes.indexOf(passingValue)!==-1){ 
        selectedWeeks.push(weeksInBytes[weeksInBytes.indexOf(passingValue)]);
        return selectedWeeks;
    }
        for(var i=(weeksInBytes.length-1);i>=0;i--){
	        if(weeksInBytes[i]<value){
	            passingValue = value - weeksInBytes[i];
	            selectedWeeks.push(weeksInBytes[i]);
	            break;
	        }
	    } 	
	    if(weeksInBytes.indexOf(passingValue)!==-1){ 
	        selectedWeeks.push(weeksInBytes[weeksInBytes.indexOf(passingValue)]);
	        return selectedWeeks;
	    }else{  
	        RecursiveWeeks(weeksInBytes,selectedWeeks,passingValue);
	    }
	return selectedWeeks;
}

export const ReminderDisplayValue =(reminderJson)=>{
    let reminderMsg = '';
    let repeatText = '';
    try{
      const reminderOnMsg = (Number(reminderJson.remind_on)===0)? 'On ':reminderJson.remind_on;
      const beforeAt = (Number(reminderJson.remind_on)===0)?' of due date at ':' before of due date at ';
      const remindAlert = ['Email','Popup','Both'];
      const remindPeriodArr =['minute(s)', 'hour(s)', 'day(s)', 'week(s)', 'month(s)', 'year(s)'];


      let remind_date = reminderJson.remind_date;
      let remind_time = reminderJson.remind_time;
      let repeat_ends = reminderJson.repeat_ends;
      let is_remind_date = reminderJson.is_remind_date;
      let is_remind_time = reminderJson.is_remind_time;
      let is_repeat_ends = reminderJson.is_repeat_ends;
      if(is_remind_date === true){
        remind_date = isSet(remind_date,[]).length>0?remind_date[0].name:''
      }
      if(is_remind_time === true){
        remind_time = isSet(remind_time,[]).length>0?remind_time[0].name:''
      }
      if(is_repeat_ends === true){
        is_repeat_ends = isSet(is_repeat_ends,[]).length>0?is_repeat_ends[0].name:''
      }

      //console.log('remind_date==',remind_date)
      // Reminder message alert
      // Check if it's a relative reminder (remind_on > 0) - show "X Day(s) before of due"
      const remindOnValue = Number(reminderJson.remind_on);
      const remindPeriodValue = reminderJson.remind_period;
      const hasValidPeriod = remindPeriodValue !== null && remindPeriodValue !== undefined && remindPeriodValue !== '' && remindPeriodArr[remindPeriodValue];
      
      if(remindOnValue > 0 && hasValidPeriod){
        // When using relative time (Other Options with remind_on > 0), show relative format
        reminderMsg+=reminderOnMsg+' '+remindPeriodArr[remindPeriodValue]+' '+beforeAt+' '+moment(remind_time, ['hh:mm a', 'HH:mm'],true).format('hh:mm a')+' by '+remindAlert[reminderJson.remind_alert];
      }else if(remind_date===null || remind_date===""){
        // When no specific date is set and remind_on is 0, show relative time format
        const periodText = hasValidPeriod ? remindPeriodArr[remindPeriodValue] : 'day(s)';
        reminderMsg+=reminderOnMsg+' '+periodText+' '+beforeAt+' '+moment(remind_time,'HH:mm',true).format('hh:mm a')+' by '+remindAlert[reminderJson.remind_alert];
      }else if(remind_date!==null && remind_date!==''){
        // When a specific date is set (remind_on === 0), format it nicely and don't include remind_on value
        let formattedDate = remind_date;
        // Try to format the date if it's in YYYY-MM-DD format
        if(moment(remind_date, 'YYYY-MM-DD', true).isValid()){
          formattedDate = moment(remind_date, 'YYYY-MM-DD', true).format('MMM Do, YYYY');
        } else if(moment(remind_date).isValid()){
          // Fallback: try parsing without format
          formattedDate = moment(remind_date).format('MMM Do, YYYY');
        }
        reminderMsg+=formattedDate+' at '+moment(remind_time, ['hh:mm a', 'HH:mm'],true).format('hh:mm a')+' by '+remindAlert[reminderJson.remind_alert];
      }

      // Repeat
      const weeksInBytes = [1,2,4,8,16,32,64];
      const weekSeq = ['First','Second','Third','Last'];
      
      repeatText+='Repeat every '+reminderJson.repeat_every+' ';
      if(reminderJson.repeat_frequency===0){
        repeatText+=(reminderJson.repeat_every>1)?' days ':' day ';
      }else if(reminderJson.repeat_frequency===1){
        let selectedWeeks = [];
        selectedWeeks = (reminderJson.repeat_weekday!==null && reminderJson.repeat_weekday!==0)?RecursiveWeeks(weeksInBytes,selectedWeeks,reminderJson.repeat_weekday):[];
        let selectedWeeksInName = [];
        console.log(selectedWeeks);
        WeeksList().map((item)=>{
          const indexOfVal = selectedWeeks.indexOf(item.value);
          if(indexOfVal!==-1){
            selectedWeeksInName.push(WeeksList()[indexOfVal].label);
          }
        })
        repeatText+= (reminderJson.repeat_every>1)?' weeks':' week'+' on '+selectedWeeksInName.join(', ');
      }else if(reminderJson.repeat_frequency===2){
        if(reminderJson.repeat_dom!==''){
          repeatText+=((reminderJson.repeat_every>1)?' months ':' month  ')+'of day '+reminderJson.repeat_dom+'';
        }else{
          let selectedWeeksInName = [];
          WeeksList().map((item)=>{
            if(Number(reminderJson.repeat_weekday)===item.value){
              selectedWeeksInName.push(item.label);
            }
          })
          repeatText+=((reminderJson.repeat_every>1)?' months ':' month ')+'of '+weekSeq[reminderJson.repeat_weekseq]+' '+selectedWeeksInName.join(',');
        }
      }else if(reminderJson.repeat_frequency===3){
        if(reminderJson.repeat_dom!==''){
          // console.log(reminderJson.repeat_month)
          repeatText+=((reminderJson.repeat_every>1)?' Years ':' year ')+' of '+MonthsList()[reminderJson.repeat_month].label+' '+reminderJson.repeat_dom+'';
        }else{
          let selectedWeeksInName = [];
          WeeksList().map((item)=>{
            if(Number(reminderJson.repeat_weekday)===item.value){  
              selectedWeeksInName.push(item.label);
            }
          })
          repeatText+=((reminderJson.repeat_every>1)?' Years ':' year ')+selectedWeeksInName.join(',')+weekSeq[reminderJson.repeat_weekseq]+' '+' of '+(MonthsList()[reminderJson.repeat_month].label);
        }
      }
      repeatText+=' ends on '+repeat_ends;
    }catch(e){

    }
    
    // console.log(JSON.stringify(reminderJson),repeatText);
    return {remind:reminderMsg,repeat:repeatText};
  }